import AddIcon from '@mui/icons-material/Add';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { IApplication, addApplication } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostDialog from "../components/PostDialog";
import { IApplicationPayload, IApplicationState, IFonctionnalite } from './interface';

interface IAddProps {
  applicationState: IApplicationState;
  setApplicationState: (x: IApplicationState) => void;
  setSelectedPhoto: (x: any) => void;
  fonctionnaliteListe: IFonctionnalite[];
  setFonctionnaliteListe: (x: IFonctionnalite[]) => void;
  photosGalerie: any;
  setPhotosGalerie: (x: any) => void;
  image: string;
  setImage: (x: string) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    applicationState,
    setApplicationState,
    setSelectedPhoto,
    fonctionnaliteListe,
    setFonctionnaliteListe,
    image,
    setImage,
    photosGalerie,
    setPhotosGalerie,
  } = props


  //hooks
  const selectPhoto: any = useRef(null);
  const selectGaleriePhoto: any = useRef(null);

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setApplicationState({ ...applicationState, [name]: value })
  }

  //Ajouter un nouveau champ fonctionnalité
  const handleAddRowFonctionnalite = () => {
    const newData = [...fonctionnaliteListe]
    setFonctionnaliteListe([...newData, { fonctionnalite: "" }])
  }

  //Supprimer un champ fonctionnalité
  const handleFonctionnaliteRowDelete = (currentIndex: number) => {
    let newData = [...fonctionnaliteListe]
    const res = newData.filter((item, index) => index !== currentIndex)
    setFonctionnaliteListe(res)
  };

  //Ecrire dans un champ fonctionnalité
  const handleFonctionnaliteInputChange = (event: any, index: number) => {
    const { name, value } = event.target;
    const updatedFonctionnaliteListeListe: any = [...fonctionnaliteListe];
    updatedFonctionnaliteListeListe[index][name] = value;
    setFonctionnaliteListe(updatedFonctionnaliteListeListe);
  };

  //Charger les images qui illustrent l'application puis les transformer en base 64
  const handleAddGaleriePhotos = (event: any) => {
    const fileList = event.target.files;
    const fileObjects: any = Array.from(fileList).map((file: any) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Lit le fichier en tant que DataURL
      // Crée une promesse pour attendre la fin de la lecture du fichier
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            name: file.name,
            size: file.size,
            type: file.type,
            lastModified: file.lastModified,
            url: reader.result // Récupère le résultat en tant que DataURL
          });
        };
      });
    });
    // Attend que toutes les promesses soient résolues
    Promise.all(fileObjects).then((results) => {
      setPhotosGalerie([...photosGalerie, ...results]);
    });
  };


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="libApp"
            label="libellé application"
            value={applicationState.libApp}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienPlaystore"
            label="Lien de téléchargement de l'application mobile android"
            value={applicationState.lienPlaystore}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienAppStore"
            label="Lien de téléchargement de l'application mobile ios"
            value={applicationState.lienAppStore}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="descriptionApp"
            label="Description"
            value={applicationState.descriptionApp}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            size="small"
            name="lienApp"
            label="lien"
            value={applicationState.lienApp}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <img
                src={image}
                style={{ width: "10vw", height: "10vh" }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger le logo de l'application">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger le logo de l'application
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Divider />
            </Grid>


            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger les images de la galérie">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ArtTrackIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectGaleriePhoto?.current?.click();
                  }}
                >
                  Charger les images de la galérie liée à cet article
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="galeriePhoto"
                ref={selectGaleriePhoto}
                onChange={handleAddGaleriePhotos}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              {photosGalerie && photosGalerie.length > 0 && (
                <div style={{ width: "100%", height: "40vh", overflow: "auto", }}>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justifyContent="flex-start"
                  >
                    {photosGalerie.map((photo: any, index: number) => (
                      <Grid key={index} item md={3} xs={3} sm={3}>
                        <img src={photo.url} alt={photo.name} style={{ width: "100%", height: "100%" }} />
                      </Grid>
                    ))}
                  </Grid>

                </div>
              )}
            </Grid>


            <Grid item md={12} xs={12} sm={12}>
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >

                {fonctionnaliteListe.map((item: any, index: number) => (
                  <Grid key={index} item md={12} xs={12} sm={12} >
                    <TextField
                      // fullWidth
                      style={{ width: "90%" }}
                      size="small"
                      name="fonctionnalite"
                      label={"Fonctionnalite" + (index + 1)}
                      value={item.fonctionnalite}
                      onChange={(e: any) => handleFonctionnaliteInputChange(e, index)}
                    />
                    <Tooltip title="Supprimer">
                      <IconButton
                        onClick={() => handleFonctionnaliteRowDelete(index)}
                        style={{ marginTop: 10 }}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ))}

                <Grid item md={12} xs={12} sm={12}>
                  <Tooltip title="Ajouter une fonctionnalité">
                    <Button
                      onClick={handleAddRowFonctionnalite}
                      startIcon={<AddIcon color="primary" />}
                    >
                      Ajouter une nouvelle fonctionnalité
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>




        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <TextField
                // fullWidth
                style={{ width: "90%" }}
                multiline
                minRows={10}
                name="texteComplet"
                label="Saisir le texte complet"
                value={applicationState.texteComplet}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    </Box>

  );
};

const initialState: IApplicationState = {
  libApp: "",
  descriptionApp: "",
  texteComplet: "",
  lienApp: "",
  lienPlaystore: "",
  lienAppStore: ""
}

const DialogAdd = () => {


  //redux
  const dispatch = useDispatch();


  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [applicationState, setApplicationState] = useState<IApplicationState>(initialState)
  const [fonctionnaliteListe, setFonctionnaliteListe] = useState<IFonctionnalite[]>([{ fonctionnalite: "" }])
  const [image, setImage] = useState<string>("");
  const [photosGalerie, setPhotosGalerie] = useState<any>([]);
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})

  //Fermer la boite de dialog d'ajout
  const onClose = () => {
    setOpen(false)
  }

  //Ouvrir la boite de dialog d'ajout
  const handleOpenDialog = () => {
    setOpen(true)
  }

  //Enregistrer un produit ou une application dans la bd
  const handleApplicationSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)
      //Obtenir les images de la galérie en base 64
      let newFonctionnaliteListe: string[] = []
      fonctionnaliteListe.map(async (item: any) => {
        newFonctionnaliteListe.push(item.fonctionnalite)
      })
      //Obtenir les images de la galérie en base 64
      let imagesDuDossierEnBase64: string[] = []
      photosGalerie.map(async (item: any) => {
        imagesDuDossierEnBase64.push(item.url)
      })
      //Obtenir l'image qui decrit l'actualité en base 64
      const logoAppEnBase64 = await convertToBase64(selectedPhoto);
      //Constituer le payload final
      const apiPayload: IApplicationPayload = {
        ...applicationState,
        logoAppEnBase64: logoAppEnBase64,
        appImagesEnBase64: imagesDuDossierEnBase64,
        checkListe: JSON.stringify(newFonctionnaliteListe)
      }
      // Envoi de la requête 
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/ajouterapplication",
        apiPayload
      );
      if (res.status === 1) {
        const formatedData = res.data.map((app: IApplication) => {
          return {
            ...app,
            checkListe: JSON.parse(app.checkListe)
          };
        });
        dispatch(addApplication(formatedData))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setApplicationState(initialState)
        setFonctionnaliteListe([{ fonctionnalite: "" }])
        setPhotosGalerie([])
        setImage("")
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handleActualiteSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          applicationState={applicationState}
          setApplicationState={setApplicationState}
          fonctionnaliteListe={fonctionnaliteListe}
          setFonctionnaliteListe={setFonctionnaliteListe}
          image={image}
          setImage={setImage}
          photosGalerie={photosGalerie}
          setPhotosGalerie={setPhotosGalerie}
          setSelectedPhoto={setSelectedPhoto}
        />}
      actionFunc={handleApplicationSave}
      title="Application"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



